export const SHIFT_ACTIVE_TAB_GROUPING_COLUMN_HEADER_MAP: Record<
  string,
  string | undefined
> = {
  info: "title",
  timeRange: "date",
  partTimeType: "partTimeType",
  appliedRequests: "numberOfApplicants",
  hireStatus: "fulfillmentCount",
};
